import React from "react";

/**
 * Key figure with a tinted icon, an optional `trend` next to it (e.g. a TrendChip)
 * and an optional `hint` line. `color` is any CSS color.
 */
const KpiCard = ({ icon, color, label, value, trend, hint, loading }) => (
  <div className="dash-card dash-kpi">
    <div className="dash-kpi-icon" style={{ "--kpi-color": color }}>
      <i className={icon} aria-hidden="true"></i>
    </div>
    <div>
      <p className="dash-kpi-label">{label}</p>
      {loading ? (
        <div className="dash-skeleton" style={{ width: 72, height: 28 }} />
      ) : (
        <>
          <p className="dash-kpi-value">
            {value}
            {trend}
          </p>
          {hint && <p className="dash-kpi-hint">{hint}</p>}
        </>
      )}
    </div>
  </div>
);

export default KpiCard;
